/* global swal, t */
import './microsoft-365.scss';

/**
 * Microsoft 365 component - handles subscriptions page functionality.
 */
export default () => {
	const element = document.querySelector( '[data-component="microsoft-365"]' );

	if ( !element ) {
		return;
	}

	const page = element.dataset.page || '';
	const config = element.dataset.config ? JSON.parse( element.dataset.config ) : {
	};

	// Route to the appropriate page handler.
	switch ( page ) {
		case 'subscriptions':
			initSubscriptionsPage( config );
			break;
		default:
			break;
	}
};

/**
 * Subscriptions page functionality.
 *
 * @param {Object} config - Page configuration with tenant.
 */
function initSubscriptionsPage ( config ) {
	const tenant = config.tenant || '';
	const tenantShort = config.tenantShort || '';
	const yearlyProducts = [
		124,
		125,
		126,
		127,
		128,
	];

	/**
	 * Resets the subscriptions table.
	 */
	function resetLicensesForm () {
		$( '.subscriptions-table tbody' ).empty();
	}

	/**
	 * Loads subscriptions from the server.
	 */
	function loadLicenses () {
		resetLicensesForm();

		const loading = $.toast( {
			heading: t( 'Aanvraag in uitvoering' ),
			text: t( 'Bezig met uitvoeren...' ),
			position: 'bottom-left',
			loaderBg: '#87888a',
			icon: 'info',
			hideAfter: 15000,
			stack: 6,
		} );

		$.ajax( {
			type: 'POST',
			dataType: 'json',
			url: '/cp/modules/microsoft-365/json/load-subscriptions.php',
			data: {
				tenant,
			},
			success ( data ) {
				loading.reset();

				$( '.subscription-count' ).html( data.details.count );
				$( '.subscription-count-container' ).show();

				if ( data.details.count > 0 ) {
					$.each( data.details.subscriptions, function ( key, subscription ) {
						// Determine if edit button should be disabled for yearly products.
						const isYearly = yearlyProducts.includes( parseInt( subscription.product_id, 10 ) );
						const editBtn = isYearly
							? `<a href="#" class="dropdown-item edit-btn-disabled">${t( 'Aanpassen' )}</a>`
							: `<a href="#" data-bs-toggle="modal" data-bs-target="#edit-modal" class="dropdown-item edit-btn">${t( 'Aanpassen' )}</a>`;

						$( '.subscriptions-table tbody' ).append( `
							<tr>
								<td>${subscription.license}</td>
								<td>${subscription.quantity}</td>
								<td>${subscription.status}</td>
								<td>${subscription.entry_date}</td>
								<td>
									<a href="" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fas fa-ellipsis-v"></i></a>
									<div class="dropdown-menu" data-quantity="${subscription.quantity}" data-license="${subscription.license}" data-cp_id="${subscription.cp_id}">
										${editBtn}
										<a class="dropdown-item text-danger remove-subscription" href="#">${t( 'Opzeggen' )}</a>
									</div>
								</td>
							</tr>
						` );
					} );
				} else {
					$( '.subscriptions-table tbody' ).append( `
						<tr>
							<td colspan="5">${t( 'Geen licenties gevonden. Bestel eerst een nieuwe licentie.' )}</td>
						</tr>
					` );
				}
			},
			error ( xhr ) {
				loading.reset();

				$.toast( {
					heading: t( 'Foutmelding' ),
					text: xhr.responseJSON?.status_description || t( 'Er is een fout opgetreden.' ),
					position: 'bottom-left',
					loaderBg: '#87888a',
					icon: 'error',
					hideAfter: 6000,
					stack: 6,
				} );
			},
		} );
	}

	// Edit button click handler - populate modal.
	$( document ).on( 'click', '.edit-btn', function () {
		const quantity = $( this ).parent().data( 'quantity' );
		const license = $( this ).parent().data( 'license' );
		const cpId = $( this ).parent().data( 'cp_id' );

		$( '#editForm input[name=quantity]' ).val( quantity );
		$( '#editForm input[name=cp_id]' ).val( cpId );
		$( '#editForm .subscription_name' ).val( license );
	} );

	// Edit modal shown - initialize validator.
	$( '#edit-modal' ).on( 'shown.bs.modal', function () {
		$( '#editForm' ).bootstrapValidator();
	} );

	// Edit modal save button handler.
	$( 'body' ).on( 'click', '#edit-modal-save', function () {
		$( '#editForm' ).submit();
	} );

	// Edit form success handler.
	$( '#editForm' ).on( 'success.form.bv', function ( e ) {
		e.preventDefault();
		$( '#edit-modal' ).modal( 'hide' );

		const quantity = $( '#editForm input[name=quantity]' ).val();
		const cpId = $( '#editForm input[name=cp_id]' ).val();

		const loading = $.toast( {
			heading: t( 'Aanvraag in uitvoering' ),
			text: t( 'Bezig met uitvoeren...' ),
			position: 'bottom-left',
			loaderBg: '#87888a',
			icon: 'info',
			hideAfter: 20000,
			stack: 6,
		} );

		$.ajax( {
			type: 'POST',
			dataType: 'json',
			url: '/cp/modules/microsoft-365/json/edit-subscription.php',
			data: {
				quantity,
				cp_id: cpId,
			},
			success ( data ) {
				loading.reset();

				$.toast( {
					heading: t( 'Succesvol' ),
					text: data.status_description,
					position: 'bottom-left',
					loaderBg: '#87888a',
					icon: 'success',
					hideAfter: 6000,
					stack: 6,
				} );

				loadLicenses();
			},
			error ( xhr ) {
				loading.reset();

				$.toast( {
					heading: t( 'Foutmelding' ),
					text: xhr.responseJSON?.status_description || t( 'Er is een fout opgetreden.' ),
					position: 'bottom-left',
					loaderBg: '#87888a',
					icon: 'error',
					hideAfter: 6000,
					stack: 6,
				} );
			},
		} );
	} );

	// Remove subscription click handler.
	$( document ).on( 'click', '.remove-subscription', function () {
		const cpId = $( this ).parent().data( 'cp_id' );

		swal( {
			title: t( 'Zeker weten?' ),
			text: t( 'Weet je zeker dat je dit abonnement wilt verwijderen? Dit gaat per direct in.' ),
			icon: 'warning',
			buttons: [
				t( 'Nee' ),
				t( 'Ja' ),
			],
		} ).then( function ( isConfirm ) {
			if ( isConfirm ) {
				const loading = $.toast( {
					heading: t( 'Aanvraag in uitvoering' ),
					text: t( 'Bezig met uitvoeren...' ),
					position: 'bottom-left',
					loaderBg: '#87888a',
					icon: 'info',
					hideAfter: 6000,
					stack: 6,
				} );

				$.ajax( {
					type: 'POST',
					dataType: 'json',
					url: '/cp/modules/microsoft-365/json/delete-subscription.php',
					data: {
						cp_id: cpId,
					},
					success ( data ) {
						loading.reset();

						$.toast( {
							heading: t( 'Succesvol' ),
							text: data.status_description,
							position: 'bottom-left',
							loaderBg: '#87888a',
							icon: 'success',
							hideAfter: 6000,
							stack: 6,
						} );

						loadLicenses();
					},
					error ( xhr ) {
						loading.reset();

						$.toast( {
							heading: t( 'Foutmelding' ),
							text: xhr.responseJSON?.status_description || t( 'Er is een fout opgetreden.' ),
							position: 'bottom-left',
							loaderBg: '#87888a',
							icon: 'error',
							hideAfter: 6000,
							stack: 6,
						} );
					},
				} );
			}
		} );
	} );

	// Disabled edit button click handler.
	$( document ).on( 'click', '.edit-btn-disabled', function ( e ) {
		e.preventDefault();
		swal( t( 'Niet mogelijk' ), t( 'Het is niet mogelijk om licenties met een jaarabonnement te wijzigen. Je kunt deze licenties wel opzeggen, of extra aanvullende licenties bijbestellen onder de dropdown "Acties".' ), 'warning' );
	} );

	// Add modal save button handler.
	$( 'body' ).on( 'click', '#add-modal-save', function () {
		$( '#addForm' ).submit();
	} );

	// Add form success handler.
	$( '#addForm' ).on( 'success.form.bv', function ( e ) {
		e.preventDefault();
		$( '#add-modal' ).modal( 'hide' );

		const productId = $( '#addForm select[name=product_id]' ).val();
		const quantity = $( '#addForm input[name=quantity]' ).val();

		const loading = $.toast( {
			heading: t( 'Aanvraag in uitvoering' ),
			text: t( 'Bezig met uitvoeren...' ),
			position: 'bottom-left',
			loaderBg: '#87888a',
			icon: 'info',
			hideAfter: 6000,
			stack: 6,
		} );

		$.ajax( {
			type: 'POST',
			dataType: 'json',
			url: '/cp/modules/order/json/add-office365.php',
			data: {
				packageId: productId,
				quantity,
				tenant: tenantShort,
			},
			success () {
				loading.reset();
				document.location.href = '/cp/order/cart/';
			},
			error ( xhr ) {
				loading.reset();

				$.toast( {
					heading: t( 'Foutmelding' ),
					text: xhr.responseJSON?.status_description || t( 'Er is een fout opgetreden.' ),
					position: 'bottom-left',
					loaderBg: '#87888a',
					icon: 'error',
					hideAfter: 6000,
					stack: 6,
				} );
			},
		} );
	} );

	// Initialize add form validator.
	$( '#addForm' ).bootstrapValidator();

	// Add modal shown - load available licenses.
	$( '#add-modal' ).on( 'shown.bs.modal', function () {
		$.ajax( {
			type: 'POST',
			dataType: 'json',
			url: '/cp/modules/microsoft-365/json/load-order-licenses.php',
			data: {
				tenant_id: 0,
			},
			success ( data ) {
				// Remove current options in modal.
				$( '#select_license' ).find( 'option' ).remove().end();

				$.each( data.details.licenses, function ( key, license ) {
					$( '#select_license' ).append( $( '<option>', {
						value: license.id,
						text: license.product,
						'data-price': license.price,
					} ) );
				} );

				$( '#addForm #select_license' ).trigger( 'change' );
			},
			error ( xhr ) {
				$.toast( {
					heading: t( 'Foutmelding' ),
					text: xhr.responseJSON?.status_description || t( 'Er is een fout opgetreden.' ),
					position: 'bottom-left',
					loaderBg: '#87888a',
					icon: 'error',
					hideAfter: 6000,
					stack: 6,
				} );
			},
		} );
	} );

	// License select change handler - update price display.
	$( document ).on( 'change', '#addForm #select_license', function () {
		const price = $( this ).find( ':selected' ).data( 'price' );

		$( '#addForm .license_price' ).val( t( '€ %s per licentie per maand', String( price ).replace( '.', ',' ) ) );
	} );

	// Reset password modal shown handler.
	$( '#reset-modal' ).on( 'shown.bs.modal', function () {
		$( 'body' ).on( 'click', '#reset-modal-save', function () {
			$( '#resetPasswordForm' ).submit();
		} );
	} );

	// Reset password form success handler.
	$( '#resetPasswordForm' ).on( 'success.form.bv', function ( e ) {
		e.preventDefault();
		$( '#reset-modal' ).modal( 'hide' );

		const password = $( '#resetPasswordForm #edit_password' ).val();

		const loading = $.toast( {
			heading: t( 'Aanvraag in uitvoering' ),
			text: t( 'Bezig met uitvoeren...' ),
			position: 'bottom-left',
			loaderBg: '#87888a',
			icon: 'info',
			hideAfter: 6000,
			stack: 6,
		} );

		$.ajax( {
			type: 'POST',
			dataType: 'json',
			url: '/cp/modules/microsoft-365/json/reset-password.php',
			data: {
				tenant_id: 0,
				password,
			},
			success ( data ) {
				loading.reset();

				$.toast( {
					heading: t( 'Succesvol' ),
					text: data.status_description,
					position: 'bottom-left',
					loaderBg: '#87888a',
					icon: 'success',
					hideAfter: 6000,
					stack: 6,
				} );
			},
			error ( xhr ) {
				loading.reset();

				$.toast( {
					heading: t( 'Foutmelding' ),
					text: xhr.responseJSON?.status_description || t( 'Er is een fout opgetreden.' ),
					position: 'bottom-left',
					loaderBg: '#87888a',
					icon: 'error',
					hideAfter: 6000,
					stack: 6,
				} );
			},
		} );
	} );

	// Initialize reset password form validator.
	$( '#resetPasswordForm' ).bootstrapValidator( {
		message: t( 'Dit veld is verplicht' ),
		fields: {
			password: {
				validators: {
					notEmpty: {
						message: t( 'Wachtwoord is verplicht' ),
					},
					stringLength: {
						min: 8,
						max: 16,
						message: t( 'Wachtwoord moet uit minimaal 8 tekens bestaan en maximaal 16 tekens' ),
					},
					regexp: {
						regexp: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9@#$%^&+=]).*$/,
						message: t( 'Minimaal 1 hoofletter, 1 kleine letter en 1 cijfer of speciaal teken verplicht' ),
					},
				},
			},
			password_check: {
				validators: {
					notEmpty: {
						message: t( 'Vul nogmaals het wachtwoord in' ),
					},
					identical: {
						field: 'password',
						message: t( 'Wachtwoord niet gelijk met bovenstaand wachtwoord' ),
					},
				},
			},
		},
	} );

	// Load licenses on page load.
	loadLicenses();
}

